import { render } from "./OrganizationViewBills.vue?vue&type=template&id=625dcb7c"
import script from "./OrganizationViewBills.vue?vue&type=script&lang=js"
export * from "./OrganizationViewBills.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__